import React from 'react';

// Recreation of the official Almaguin Highlands Chamber of Commerce mark:
// three layered pine trees standing on a curved hill inside a ring.
// variant: 'white' (over imagery) | 'blue' (on light backgrounds)
export default function Logo({ variant = 'white', className = '' }) {
  const isWhite = variant === 'white';
  const c = isWhite ? '#ffffff' : '#4a9cd4';
  const cText = isWhite ? '#ffffff' : '#4a9cd4';

  // layered pine path centered at x=0, base at y=0, pointing up
  const pine = 'M0 -34 L7 -22 L3.5 -22 L11 -9 L6 -9 L15 6 L8 6 L18 22 L-18 22 L-8 6 L-15 6 L-6 -9 L-11 -9 L-3.5 -22 L-7 -22 Z';

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg width="58" height="58" viewBox="0 0 120 120" fill="none" aria-hidden="true">
        <circle cx="60" cy="60" r="55" stroke={c} strokeWidth="6" fill="none" />
        {/* clip so trees/hill stay inside the ring */}
        <defs>
          <clipPath id={`ring-${variant}`}>
            <circle cx="60" cy="60" r="52" />
          </clipPath>
        </defs>
        <g clipPath={`url(#ring-${variant})`}>
          {/* three pines: left small, middle tall, right medium */}
          <g transform="translate(38 86) scale(0.62)">
            <path d={pine} fill={c} />
            <rect x="-3" y="22" width="6" height="12" fill={c} />
          </g>
          <g transform="translate(60 88) scale(1)">
            <path d={pine} fill={c} />
            <rect x="-3.2" y="22" width="6.4" height="14" fill={c} />
          </g>
          <g transform="translate(82 86) scale(0.72)">
            <path d={pine} fill={c} />
            <rect x="-3" y="22" width="6" height="12" fill={c} />
          </g>
          {/* curved hill the trees stand on */}
          <path d="M-6 110 Q60 86 126 110 L126 130 L-6 130 Z" fill={c} />
        </g>
      </svg>

      {/* Wordmark */}
      <div className="leading-none relative">
        <div className="font-brand" style={{ color: cText, fontSize: '30px', fontWeight: 600, letterSpacing: '-0.5px', lineHeight: 1 }}>
          Almaguin
        </div>
        <div className="flex items-end gap-2">
          <span className="font-script" style={{ color: cText, fontSize: '26px', lineHeight: 0.8, marginTop: '-6px', marginLeft: '6px' }}>
            Highlands
          </span>
          <span
            className="font-brand"
            style={{ color: cText, fontSize: '7px', fontWeight: 600, letterSpacing: '0.5px', lineHeight: 1.1, marginBottom: '3px' }}
          >
            CHAMBER
            <br />
            OF COMMERCE
          </span>
        </div>
      </div>
    </div>
  );
}
